var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useRef, useEffect } from 'react';
const VideoBox = ({ deviceId, onSourcePlayback, onMediaStream, }) => {
    _react_refresh_temp_2();
    const ref = useRef(null);
    useEffect(() => {
        const el = ref.current;
        const constraints = {
            video: {
                deviceId,
            },
        };
        navigator.mediaDevices.getUserMedia(constraints).then((mediaStream) => {
            if (el) {
                onMediaStream(mediaStream);
                el.srcObject = mediaStream;
            }
        });
        return () => {
            if (el) {
                el.pause();
                el.removeAttribute('src'); // empty source
            }
        };
    }, [deviceId]);
    const handleVideoLoad = (event) => {
        var _a, _b;
        const video = event.target;
        onSourcePlayback({
            htmlElement: video,
            width: (_a = video.videoWidth) !== null && _a !== void 0 ? _a : 330,
            height: (_b = video.videoHeight) !== null && _b !== void 0 ? _b : 200,
        });
    };
    return (_jsx("div", { className: "preview-camera-webcam", children: _jsx("video", { className: "my-5 w-full", ref: ref, autoPlay: true, height: "50", onLoadedData: handleVideoLoad }) }));
};
_react_refresh_temp_1 = VideoBox;
$RefreshReg$(_react_refresh_temp_1, "VideoBox");
_react_refresh_temp_2(VideoBox, "8uVE59eA/r6b92xF80p7sH8rXLk=");
export default VideoBox;
